<template>
  <div
    class="col-lg-3 col-12 col-md-6 justify-content-between d-flex flex-column"
  >
    <div class="card-dash">
      <p class="text-center p-card">
        <img
          v-if="kind === 'likes'"
          :src="require('@/assets/images/svg/icone-coracao.svg')"
          class="img-fluid"
          style="margin-right: 4px"
        />
        <img
          v-if="kind === 'shares'"
          :src="require('@/assets/images/svg/icone-share.svg')"
          class="img-fluid"
          style="margin-right: 4px"
        />
        <img
          v-if="kind === 'saves'"
          :src="require('@/assets/images/svg/icone-salvar.svg')"
          class="img-fluid"
          style="margin-right: 4px"
        />
        {{ selectTitle }}
        <img
          v-if="showArrow"
          :src="require('@/assets/images/svg/seta.svg')"
          class="img-fluid"
          style="max-width: 5%; margin-left: 5px"
          alt="imagem seta"
        />
      </p>
      <h2 class="text-center h2-card">
        {{ treatDecimalNumbers() }}

        <span
          v-if="kind == 'follow'"
          :class="value2 > 0 ? 'por-card' : 'por-card-red'"
          >{{ Math.round(value2) }}%</span
        >

        <span
          v-if="kind == 'followRange'"
          :class="value2 > 0 ? 'por-card' : 'por-card-red'"
          >{{ value2 }}</span
        >
      </h2>
      <p class="text-center p-card" style="font-size: 12px">
        {{ filter }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, required: true },
    value2: { type: Number, required: false },
    kind: { type: String, required: true },
    filter: { type: String, required: true },
  },
  computed: {
    selectTitle() {
      switch (this.kind) {
        case "follow":
          return "Seguidores";
        case "followRange":
          return "Variação de seguidores";
        case "likes":
          return "Curtidas";
        case "comments":
          return "Comentários";
        case "visits":
          return "Visitas";
        case "clicks":
          return "Cliques no perfil";
        case "shares":
          return "Compartilhamento";
        case "saves":
          return "Salvos";
        default:
          return "Dados";
      }
    },
    showArrow() {
      if (this.kind === "likes") return true;
      if (this.kind === "comments") return true;
      if (this.kind === "shares") return true;
      if (this.kind === "saves") return true;

      return false;
    },
  },

  methods: {
    treatDecimalNumbers() {
      let value = this.value.toString();

      if (value.length === 4) {
        return value.substring(0, 1) + "." + value.substring(1);
      } else if (value.length === 5) {
        return value.substring(0, 2) + "." + value.substring(2);
      } else if (value.length === 6) {
        return value.substring(0, 3) + "." + value.substring(3);
      } else if (value.length === 7) {
        return value.substring(0, 1) + "." + value.substring(1);
      } else if (value.length === 8) {
        return value.substring(0, 2) + " M";
      } else if (value.length === 9) {
        return value.substring(0, 1) + " B";
      } else {
        return value;
      }
    },
  },

  beforeMount() {
    this.treatDecimalNumbers();
  },
};
</script>

<style scoped>
.card-dash {
  width: 90%;
  padding: 16px 40px 6px 40px;
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: 0px 24px 38px rgba(9, 15, 37, 0.07);
}

.p-card {
  color: #80848a;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

.por-card {
  color: #2cbf59 !important;
  background: rgba(44, 191, 89, 0.1);
  border-radius: 8px;
  font-size: 13px;
  padding: 3px;
}

.por-card-red {
  color: #e51717 !important;
  background: rgba(229, 23, 23, 0.1);
  border-radius: 8px;
  font-size: 13px;
  padding: 3px;
}
</style>
